module.exports = __webpack_public_path__ + "static/media/43.0b98bb1c.ogg";